import React, { useState, useCallback, useRef, useEffect, useMemo } from 'react';
import Select from 'react-select';
import { Accordion, Card, Tab, Tabs } from 'react-bootstrap';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { DndProvider } from 'react-dnd';
import { cloneDeep, isEmpty, concat, isArray, last, flatMap } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import noImage from '../../../../../assets/images/no-image.png';
import {
  calculationProductListSubLocationsArray,
  customStylesWithBorderRight,
  customStylesForOCP,
  ColumnValues,
  PCPLocation,
  checValidMongoId,
  productListLocationsArray,
  calculationBtnArrays,
  splitAndFilterString,
  handleSubLocation,
  RightsAccess,
  customStyles,
  imageUrl,
} from '../../../../../Components/helper';
import RenderLabelOption from '../RenderLabelOption';
import UploadImageModal from './UploadImageModal';
import TableSourceComponent from './TableSourceComponent';
import TableCalculation from './TableCalculation';
import * as customAction from '../../../../RangePlan/CustomSections/store/CustomSections.action';
import * as systemMasterAction from '../../../../SystemMasters/Store/SystemMasters.action';
import * as action from '../../Store/CustomModule.action';
import TableDependent from './TableDepndent';
import AlignmentConfigComp from '../ControlConfig/AlignmentConfig';
import BoldConfigComp from '../ControlConfig/BoldConfig';

function ColumnCard({
  element,
  editMode,
  selectValue,
  tableControls,
  onChange,
  colIndex,
  keyHasOption,
  handleOptionChange,
  handleBlurOption,
  handleBlur,
  errors,
  columnStateData,
  handleAddColumn,
  handleDeleteColumn,
  handleAddMoreOption,
  handleDeleteOption,
  handleChange,
  handleDependentChange,
  relation,
  changeRelationState,
  onLocationChange,
  setState,
  addContent,
  deleteCard,
  i,
  childOptions,
  setDisableMainBtn,
  hideCustomModule,
  rootAtLast,
  formulaHasError,
  setFormulaHasError,
}) {
  const deleteOptions = 'CUSTOM_MODULES.LIBRARY.TABLE.COLUMN_CARD.DELETE_OPTION';
  const locationRef = useRef(null);
  const subLocationRef = useRef(null);
  const pageRef = useRef(null);
  const controlRef = useRef(null);
  const { t } = useTranslation('common');
  const { rangePlanRight } = RightsAccess();
  const {
    UserDetails: { userInfo },
    SystemMastersDetails: { mainSampleList, otherSamplesList },
    customSectionData: { currSectionList, customColumnList, dynamicColArr, measurementArr, sampleTrackingDates },
    CustomModuleReducer: {
      customLibraryList,
      customModulePageControlList,
      customLibraryCalculationList,
      customLibraryPagesCalculationList,
      customLibraryPageControlsCalculationList,
    },
  } = useSelector((reducer) => reducer);
  const dispatch = useDispatch();
  const loggedInUserId = userInfo?.userId;
  const [isStatusEditTrue, setIsStatusEditTrue] = useState(false);
  const [colourSwitch, setColourSwitch] = useState(false);
  const [imageModal, setImageModal] = useState({
    isOpen: false,
    controlKey: '',
  });
  const [locationOptions, setLocationOptions] = useState(PCPLocation);
  const [customOptions, setCustomOptions] = useState([]);
  const [controlOptions, setControlOptions] = useState([]);
  const [manualCustomColumns, setManualCustomColumns] = useState([]);
  const [allowEditFormula, setAllowEditFormula] = useState(false);
  const foundString = relation?.formulaArray?.filter((val) => val?.subLocation?.type === 'string');
  const checkFormulaHasStringType = foundString?.length > 0;
  const counterState = relation?.counter === 0;

  const checkFormulaHasPercentage = () => {
    const lastObj = last(relation?.formulaArray);
    return ['%'].includes(lastObj?.subLocation?.name);
  };
  const checkFormulaHasRoot = () => {
    const lastObj = last(relation?.formulaArray);
    return ['√'].includes(lastObj?.subLocation?.name);
  };

  const checkDisableNumbers = () => {
    const lastObj = last(relation?.formulaArray);
    return ['X²', 'π', ')'].includes(lastObj?.subLocation?.name);
  };

  const checkDisableSpecials = () => {
    const lastObj = last(relation?.formulaArray);
    return lastObj?.subLocation?.type === 'Number';
  };

  const checkSqAtLast = () => {
    const lastObj = last(relation?.formulaArray);
    return lastObj?.subLocation?.name === 'X²';
  };

  const checkPiAtLast = () => {
    const lastObj = last(relation?.formulaArray);
    return lastObj?.subLocation?.name === 'π';
  };

  const checkFormulaHasPercentageAtLast = useMemo(() => {
    return {
      percentage: checkFormulaHasPercentage(),
      root: checkFormulaHasRoot(),
      disableNumbers: checkDisableNumbers(),
      disableSpecialCharacter: checkDisableSpecials(),
      squareAtLast: checkSqAtLast(),
      piAtLast: checkPiAtLast(),
      closingBreak: !relation?.bracketCounter,
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [relation?.formulaArray?.length]);
  const fontSizeTextControl = [
    { label: '11 px', value: '11' },
    { label: '13 px', value: '13' },
    { label: '15 px', value: '15' },
    { label: '17 px', value: '17' },
  ];
  useEffect(() => {
    setColourSwitch(element?.isColourCoding);
  }, [element]);
  const childRef = useRef();
  const forSwitch = (e) => {
    setColourSwitch(e?.target?.checked);
    onChange(e?.target?.checked, colIndex, 'isColourCoding');
  };
  const varCompanyStamp = 'Company Stamp';
  const chcekingFromDynamicArray = (colourArray, value) => {
    return typeof value === 'object' ? colourArray?.find((ele) => ele?._id === value?._id) : colourArray?.find((ele) => ele?._id === value);
  };
  const getImage = (imagePath) => {
    let logo = null;
    if (imagePath?.includes('base64')) {
      logo = imagePath;
    } else {
      logo = `${imageUrl}/${imagePath}`;
    }
    return logo;
  };
  const alignBoldControls = ['Text_Area', 'Text', 'Number_Decimal', 'Number_percentage', 'Calculation'];

  const swapArrayLocs = (arr, index1, index2) => {
    // Create a new array instead of modifying the parameter directly
    const newArr = [...arr];

    // Swap elements in the new array
    const temp = newArr[index1];
    newArr[index1] = newArr[index2];
    newArr[index2] = temp;

    return newArr;
  };

  const moveLabel = (dragIndex, hoverIndex) => {
    const object = { ...element };
    const currList = swapArrayLocs(object.labelColours, dragIndex, hoverIndex);
    object.labelColours = currList;
    onChange(currList, colIndex, 'labelColours');
  };
  const removelabel = (index) => {
    const object = { ...element };
    object.labelColours.splice(index, 1);
    onChange(object.labelColours, colIndex, 'labelColours');
  };
  const handleLabelChange = (value, index, key) => {
    const object = { ...element };
    object.labelColours[index][key] = value;
    onChange(object.labelColours, colIndex, 'labelColours');
  };
  const renderlabelList = useCallback(
    (label, labelIndex) => {
      return (
        <RenderLabelOption // label Item changes
          column={label}
          index={labelIndex}
          moveCard={moveLabel}
          id={`${label?.Nmae}_${labelIndex}`}
          removeLabel={removelabel}
          handleChange={handleLabelChange}
          wholeArry={element?.labelColours}
        />
      );
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [element?.labelColours],
  );

  const handleFont = (e) => {
    const object = cloneDeep(element);
    object.fontFamily = e;

    onChange(object.fontFamily, colIndex, 'fontFamily');
  };

  const handleUploadImage = (key) => {
    setImageModal((prevState) => ({
      ...prevState,
      isOpen: true,
      controlKey: key,
    }));
  };

  const handleImageUpload = async (type) => {
    if (type !== 'close') {
      const croppedFileUrl = await childRef.current.showCroppedImg();
      const { imageRes } = croppedFileUrl;
      if (imageRes?.length) {
        const object = { ...element };
        if (imageModal.controlKey === 'Signature') {
          object.digitalSignPath = imageRes;
          onChange(object.digitalSignPath, colIndex, 'digitalSignPath');
        } else {
          object.companyLogo = imageRes;
          onChange(object.companyLogo, colIndex, 'companyLogo');
        }

        setImageModal((prevState) => ({
          ...prevState,
          isOpen: false,
        }));
      }
    } else {
      setImageModal((prevState) => ({
        ...prevState,
        isOpen: false,
      }));
    }
  };

  const handleRemoveImage = (key) => {
    const object = { ...element };
    if (key === 'Signature') {
      object.digitalSignPath = '';
      onChange(object.digitalSignPath, colIndex, 'digitalSignPath');
    } else if (key === varCompanyStamp) {
      object.companyLogo = '';
      onChange(object.companyLogo, colIndex, 'companyLogo');
    }
  };

  useEffect(() => {
    const callFn = async () => {
      if (rangePlanRight) {
        await dispatch(customAction.fetchAllSections());
      }
      await Promise.all([
        dispatch(action.getAllCustomModule({ isAllRecord: true })),
        dispatch(customAction.fetchCustomSectionBomTypeAction({ isAllRecord: true })),
        dispatch(systemMasterAction.getMainSampleDetails({ loggedInUserId })),
        dispatch(systemMasterAction.getOtherSamplesDetails({ loggedInUserId })),
        dispatch(systemMasterAction.getPlacementDetails({ loggedInUserId, isActive: true })),
        dispatch(systemMasterAction.getCustomAttributeFreeText({ isActive: true })),
        dispatch(customAction.getAllMeasurment()),
        dispatch(customAction.getSampleTrackingDates()),
      ]);
    };
    if (!isEmpty(loggedInUserId) && element?.key === 'Source') callFn();
  }, [loggedInUserId, rangePlanRight, dispatch, element?.key]);

  useEffect(() => {
    if (customColumnList && element?.key === 'Source') {
      const manualColumns = [];
      manualColumns.push(
        ...(customColumnList?.columns ?? []).filter(
          (colmElement) => colmElement?.columnType === 'manual' && (colmElement?.type === 'Number' || colmElement?.type === 'Number_percentage'),
        ),
      );
      setManualCustomColumns(manualColumns?.map((cEle) => ({ label: cEle?.title, name: cEle?._id })));
    }
  }, [customColumnList, element?.key]);

  useEffect(() => {
    const allColumns = [];
    if (currSectionList && !isEmpty(currSectionList) && element?.key === 'Source') {
      currSectionList?.forEach((sectionElement) => {
        const checkManualExist = sectionElement?.columns?.find((vl) => vl?.columnType === 'manual');
        if (checkManualExist) {
          allColumns.push(sectionElement);
        }
      });
      const maualColumns = allColumns?.map((cEle) => {
        return {
          label: cEle?.name,
          name: cEle?._id,
          _id: 12,
        };
      });
      setLocationOptions((arr) => [...arr, ...maualColumns]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currSectionList, element?.key]);

  const apiCallForSubLocation = async () => {
    changeRelationState(colIndex, 'loading', true);
    const res = await Promise.all([
      dispatch(action.getCMPagesList(relation?.subLocation?.name)),
      dispatch(action.getCMPageControlList(relation?.subLocation?.name, relation?.pages?.name)),
    ]);
    if (res) {
      changeRelationState(colIndex, 'loading', false);
    }
  };

  const fetchingCustomColumns = async (value) => {
    changeRelationState(colIndex, 'loading', true);
    if (value?.name) {
      const res = await dispatch(customAction.fetchCustomColumnList(value?.name));
      if (res) {
        changeRelationState(colIndex, 'loading', false);
      }
    }
  };

  // handling edit Case
  useEffect(() => {
    if (editMode && element?.key === 'Source') {
      if (relation?.subLocation && relation?.location?._id === 12) {
        fetchingCustomColumns();
      }
      if (relation?.subLocation && relation?.location?._id === 7) {
        apiCallForSubLocation();
      }
    }
    if (editMode && element?.key === 'Calculation') {
      relation.currLocation = productListLocationsArray[0];
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editMode, element?.key]);

  useEffect(() => {
    if (customLibraryList && !isEmpty(customLibraryList) && element?.key === 'Source') {
      const maualCustomColumns = customLibraryList?.map((cEle) => {
        return {
          label: cEle?.moduleName,
          name: cEle?._id,
          _id: 7,
        };
      });
      setCustomOptions(maualCustomColumns);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customLibraryList, element?.key]);

  useEffect(() => {
    if (relation?.location?._id === 7 && relation?.pages && element?.key === 'Source') {
      const clonedData = cloneDeep(customModulePageControlList);
      const controls = clonedData
        ?.filter((ele) => {
          return ele?.control && !['Colorfill', 'Divider', 'Source'].includes(ele?.control?.key);
        })
        ?.map((ele) => {
          const { options, ...rest } = ele.control;
          return { ...rest, name: rest.key, parentType: 'control', i: ele.i }; // add here
        });
      setControlOptions(controls);
    }
  }, [customModulePageControlList, relation?.pages, element?.key, relation?.location?._id]);

  useEffect(() => {
    const sampleSelectionType = concat(mainSampleList, otherSamplesList).map((ele) => {
      return { label: ele?.name, name: ele?._id };
    });
    if (element?.key === 'Source' && isEmpty(element?.relation?.sampleType) && sampleSelectionType.length > 0) {
      changeRelationState(colIndex, 'sampleType', sampleSelectionType);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mainSampleList, otherSamplesList, element?.key]);

  useEffect(() => {
    if (element?.key === 'Calculation') {
      const fetchCalculation = async () => {
        if (rangePlanRight) {
          await Promise.all([
            dispatch(customAction.fetchAllSections()),
            dispatch(customAction.getAllCustomAttributes()),
            dispatch(customAction.getAllMeasurment()),
            dispatch(customAction.getSampleTrackingDates()),
          ]);
        }
      };
      fetchCalculation();
    }
  }, [dispatch, rangePlanRight, element?.key]);

  useEffect(() => {
    if (isArray(currSectionList) && currSectionList.length > 0 && element?.key === 'Calculation') {
      const manipulatedSectionList = currSectionList?.map((section) => {
        return {
          label: section?.name,
          name: section?._id,
        };
      });
      const clonedData = cloneDeep(columnStateData);
      clonedData[colIndex].relation.locationArray = [...(productListLocationsArray || []), ...manipulatedSectionList];
      clonedData[colIndex].relation.filteredLocationArray = [...(productListLocationsArray || []), ...manipulatedSectionList];
      setState((prev) => ({
        ...prev,
        columnStateData: clonedData,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currSectionList, colIndex, element?.key]);

  useEffect(() => {
    if (editMode && element?.key === 'Calculation') {
      const lastObj = last(relation?.formulaArray);
      const obj = { counter: 0 };
      if (
        [')'].includes(lastObj?.subLocation?.name) ||
        ['number', 'Number', 'Number_percentage'].includes(lastObj?.subLocation?.type) ||
        lastObj?.subLocation?.type === 'string' ||
        (lastObj?.subLocation?.type === 'symbol' && lastObj?.subLocation?.name === '%')
      ) {
        obj.counter = 1;
      } else if (lastObj?.subLocation?.type === 'symbol') {
        obj.counter = 0;
      }
      const clonedData = cloneDeep(columnStateData);
      clonedData[colIndex].relation.counter = obj?.counter;

      setState((prev) => ({
        ...prev,
        columnStateData: clonedData,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editMode, relation?.formulaArray?.length, element?.key]);

  const finalChanges = (cloneRedoArr, copyFormulaArr, counter, clonedData) => {
    if (cloneRedoArr) {
      clonedData[colIndex].relation.redo = cloneRedoArr;
    }
    if (copyFormulaArr) {
      clonedData[colIndex].relation.undo = copyFormulaArr;
    }
    if (![-1, null, undefined, ''].includes(counter)) {
      clonedData[colIndex].relation.counter = counter;
      clonedData[colIndex].relation.currSubLocation = null;
    }
  };

  const updateFormulaString = (formulaArrays, cloneRedoArr, copyFormulaArr, counter) => {
    const clonedData = cloneDeep(columnStateData);
    let getCurrFormulaString = '';
    let readOnlyFormulaString = '';
    if (clonedData[colIndex].relation?.currLocation?.name === 'Custom_Modules') {
      formulaArrays?.forEach((formula) => {
        if (['symbol', 'Number'].includes(formula?.location?.type) || formula?.location?.name !== 'Custom_Modules') {
          getCurrFormulaString = getCurrFormulaString.concat(formula?.subLocation?.name, '');
          readOnlyFormulaString = readOnlyFormulaString.concat(formula?.subLocation?.label, '');
        } else if (formula?.control?.type === 'Table') {
          getCurrFormulaString = getCurrFormulaString.concat(`${formula?.control?.name}_${formula?.column?.key}`, '');
          readOnlyFormulaString = readOnlyFormulaString.concat(`${formula?.control?.label}_${formula?.column?.name}`, '');
        } else {
          getCurrFormulaString = getCurrFormulaString.concat(formula?.control?.name, '');
          readOnlyFormulaString = readOnlyFormulaString.concat(formula?.control?.label, '');
        }
      });
    } else {
      formulaArrays?.forEach((formula) => {
        if (formula?.row) {
          getCurrFormulaString = getCurrFormulaString.concat(`${formula?.control?.name}_${formula?.column?.key}_${formula?.row?.rowIndex}`, '');
          readOnlyFormulaString = readOnlyFormulaString.concat(`${formula?.control?.label}_${formula?.column?.name}_${formula?.row?.name}`, '');
        } else if (formula?.control) {
          getCurrFormulaString = getCurrFormulaString.concat(formula?.control?.name, '');
          readOnlyFormulaString = readOnlyFormulaString.concat(formula?.control?.label, '');
        } else {
          getCurrFormulaString = getCurrFormulaString.concat(formula?.subLocation?.name, '');
          readOnlyFormulaString = readOnlyFormulaString.concat(formula?.subLocation?.label, '');
        }
      });
    }
    clonedData[colIndex].relation.formulaArray = formulaArrays;
    clonedData[colIndex].relation.formulaString = getCurrFormulaString;
    clonedData[colIndex].relation.readOnlyFormulaString = readOnlyFormulaString;
    if (cloneRedoArr) {
      clonedData[colIndex].relation.redo = cloneRedoArr;
    }
    if (copyFormulaArr) {
      clonedData[colIndex].relation.undo = copyFormulaArr;
    }
    if (![-1, null, undefined, ''].includes(counter)) {
      clonedData[colIndex].relation.counter = counter;
      clonedData[colIndex].relation.currSubLocation = null;
    }
    finalChanges(cloneRedoArr, copyFormulaArr, counter, clonedData);
    setState((prev) => ({
      ...prev,
      columnStateData: clonedData,
    }));
  };

  const converDropdownData = (allTypeData) => {
    const allData = cloneDeep(allTypeData);
    let filteredData = [];
    let filteredDropdownData = allData?.filter((ele) => ele?.type === 'dropdown' && ele?.isLable === true);
    const filteredTextData = allData?.filter((ele) => ele?.type === 'text' && ele?.isLable === false);
    if (!isEmpty(filteredDropdownData)) {
      filteredDropdownData = filteredDropdownData.map((item) => {
        const valuesForLabel = allData.filter((ele) => item._id === ele.lableId);
        item.options = valuesForLabel;
        return item;
      });
    }
    if (isArray(filteredDropdownData) && isArray(filteredTextData)) {
      filteredData = filteredDropdownData.concat(filteredTextData);
    }
    return filteredData;
  };

  function manupulateSubLocationArr(subLocationArr, manipulatedDynamicColumns, manipulatedMeasurmentArr, sampleTrackingArr) {
    if (relation?.currLocation?.name === 'Product_Information') {
      subLocationArr.subLocations = concat(subLocationArr?.subLocations, manipulatedDynamicColumns);
    }
    if (relation?.currLocation?.name === 'Measurement_Information') {
      subLocationArr.subLocations = concat(subLocationArr?.subLocations, manipulatedMeasurmentArr);
    }
    if (relation?.currLocation?.name === 'Sample_Information') {
      subLocationArr.subLocations = concat(subLocationArr?.subLocations, sampleTrackingArr);
    }
    if (checValidMongoId(relation?.currLocation?.name)) {
      const getSectionsColumns = cloneDeep(currSectionList?.find((val) => val?._id === relation?.currLocation?.name));
      const subLocationObj = {};
      if (getSectionsColumns && isArray(getSectionsColumns?.columns) && getSectionsColumns?.columns.length > 0) {
        const newSubColumns = getSectionsColumns?.columns?.map((dyCol) => {
          const obj = {
            label: dyCol?.title,
          };
          if (dyCol?.columnType === 'calculation') {
            obj.name = dyCol?.formulaArr;
            obj.type = 'number';
          } else if (dyCol?.columnType === 'source') {
            obj.name = [dyCol?.source];
            obj.type = 'number';
          } else if (dyCol?.columnType === 'manual') {
            obj.name = dyCol?._id;
            obj.type = 'manualNumber';
            obj.numberType = dyCol?.key;
          } else {
            console.error('dyCol=================', dyCol);
          }
          return obj;
        });

        subLocationObj.locationId = relation?.currLocation?.name;
        subLocationObj.subLocations = newSubColumns;
      }
      subLocationArr = subLocationObj;
      return subLocationArr;
    }
  }
  const setSubLocationArr = () => {
    let subLocationArr = cloneDeep(calculationProductListSubLocationsArray?.find((val) => val?.locationId === relation?.currLocation?._id) || null);
    if (relation?.currLocation?._id === 10) {
      const options = customLibraryCalculationList?.map((ele) => ({
        label: ele?.moduleName,
        name: ele?._id,
        type: 'string',
      }));
      subLocationArr = { locationId: 10, subLocations: options };
    } else {
      let manipulatedDynamicColumns = converDropdownData(dynamicColArr);
      manipulatedDynamicColumns = manipulatedDynamicColumns?.map((dyCol) => {
        return {
          label: dyCol?.keyName,
          name: dyCol?._id,
          type: 'string',
        };
      });
      const manipulatedMeasurmentArr = measurementArr.map((dyCol) => {
        return {
          label: dyCol?.name,
          name: dyCol?._id,
          type: 'number',
        };
      });
      const sampleTrackingArr = sampleTrackingDates.map((dyCol) => {
        return {
          label: dyCol?.name,
          name: dyCol?._id,
          type: 'string',
        };
      });
      manupulateSubLocationArr(subLocationArr, manipulatedDynamicColumns, manipulatedMeasurmentArr, sampleTrackingArr);
    }
    return subLocationArr;
  };

  useMemo(() => {
    if (element?.key === 'Calculation') {
      const subLocate = setSubLocationArr();
      const clonedData = cloneDeep(columnStateData);
      relation.subLocationArray = subLocate?.subLocations;
      relation.filteredSubLocationArray = subLocate?.subLocations;
      clonedData[colIndex].relation.subLocationArray = subLocate?.subLocations;
      clonedData[colIndex].relation.filteredSubLocationArray = subLocate?.subLocations;
      clonedData[colIndex].relation.mainLoader = false;
      setState((prev) => ({
        ...prev,
        columnStateData: clonedData,
      }));
      return subLocate;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [relation?.currLocation?.name, element?.key]);

  const setPageLocationArr = () => {
    let subLocationArr = {};
    const options = customLibraryPagesCalculationList?.map((ele) => ({
      label: ele?.pageTitle,
      name: ele?._id,
    }));
    subLocationArr = { ...subLocationArr, pages: options };
    return subLocationArr;
  };

  useMemo(() => {
    if (element?.key === 'Calculation' && relation?.currLocation?._id === 10 && relation?.currSubLocation) {
      const subLocate = setPageLocationArr();
      const clonedData = cloneDeep(columnStateData);
      relation.pageArray = subLocate.pages || [];
      relation.filteredPageArray = subLocate.pages || [];
      clonedData[colIndex].relation.pageArray = subLocate.pages || [];
      clonedData[colIndex].relation.filteredPageArray = subLocate.pages || [];
      setState((prev) => ({
        ...prev,
        columnStateData: clonedData,
      }));
      return subLocate;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [relation?.currSubLocation?.name, element?.key, customLibraryPagesCalculationList]);

  const setControlsLocationArr = () => {
    let subControlLocationArray = {};
    const options = customLibraryPageControlsCalculationList?.map((ele) =>
      ele?.control?.key === 'Table'
        ? {
            label: ele?.control?.labelInModal ? ele?.control?.labelInModal : ele?.control?.label,
            name: ele?.i,
            type: 'Table',
            tableColumns: ele?.control?.tableColumns
              ?.filter((e) =>
                ['Heading', 'Text_Area', 'Textbox', 'Dropdown', 'Ratio_Button', 'Number_Decimal', 'Number_Percentage', 'Calculation'].includes(e?.key),
              )
              ?.map((e) => ({
                name: e?.fieldName,
                key: e?.key,
                type: ['Number_Decimal', 'Number_Percentage', 'Calculation'].includes(e?.key) ? 'number' : 'string',
              })),
          }
        : {
            label: ele?.control?.labelInModal ? ele?.control?.labelInModal : ele?.control?.label,
            name: ele?.i,
            type: ['Number', 'Number_Decimal', 'Number_Percentage', 'Calculation'].includes(ele?.control?.key) ? 'number' : 'string',
          },
    );
    subControlLocationArray = { ...subControlLocationArray, controls: options };
    return subControlLocationArray;
  };

  useMemo(() => {
    if (element?.key === 'Calculation' && relation?.currLocation?._id === 10 && relation?.currSubLocation && relation?.currPage) {
      const subLocate = setControlsLocationArr();
      const clonedData = cloneDeep(columnStateData);
      relation.controlsArray = subLocate.controls || [];
      relation.filteredControlsArray = subLocate.controls || [];
      clonedData[colIndex].relation.controlsArray = subLocate.controls || [];
      clonedData[colIndex].relation.filteredControlsArray = subLocate.controls || [];
      setState((prev) => ({
        ...prev,
        columnStateData: clonedData,
      }));
      return subLocate;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [relation?.currPage?.name, element?.key, customLibraryPageControlsCalculationList]);

  const clearLocation = (type) => {
    const clonedData = cloneDeep(columnStateData);
    if (type === 'location') {
      if (customLibraryCalculationList?.length > 0) {
        action.clearCalculationList();
      }
      if (customLibraryPagesCalculationList?.length > 0) {
        action.clearCalculationPageList();
      }
      if (customLibraryPageControlsCalculationList?.length > 0) {
        action.clearCalculationControlList();
      }
      const subLocate = cloneDeep(calculationProductListSubLocationsArray?.find((val) => val?.locationId === relation?.locationArray?.[0]?._id) || {});
      locationRef.current.value = '';
      clonedData[colIndex].relation.filteredLocationArray = relation?.locationArray;
      clonedData[colIndex].relation.filteredSubLocationArray = subLocate?.subLocations || [];
      clonedData[colIndex].relation.currLocation = {
        label: 'Product Core Information',
        name: 'Product_Core_Information',
        _id: 11,
      };
      clonedData[colIndex].relation.currSubLocation = null;
      clonedData[colIndex].relation.currPage = null;
      clonedData[colIndex].relation.currControl = null;
      clonedData[colIndex].relation.filteredPageArray = [];
      clonedData[colIndex].relation.pageArray = [];
      clonedData[colIndex].relation.controlsArray = [];
      clonedData[colIndex].relation.filteredControlsArray = [];
      clonedData[colIndex].relation.currentColumn = null;
    } else if (type === 'subLocation') {
      subLocationRef.current.value = '';
      if (customLibraryPagesCalculationList?.length > 0) {
        action.clearCalculationPageList();
      }
      if (customLibraryPageControlsCalculationList?.length > 0) {
        action.clearCalculationControlList();
      }
      clonedData[colIndex].relation.filteredSubLocationArray = relation?.subLocationArray || [];
      clonedData[colIndex].relation.currPage = null;
      clonedData[colIndex].relation.currControl = null;
      clonedData[colIndex].relation.filteredPageArray = [];
      clonedData[colIndex].relation.pageArray = [];
      clonedData[colIndex].relation.controlsArray = [];
      clonedData[colIndex].relation.filteredControlsArray = [];
      clonedData[colIndex].relation.currentColumn = null;
    } else if (type === 'page') {
      if (customLibraryPageControlsCalculationList?.length > 0) {
        action.clearCalculationControlList();
      }
      pageRef.current.value = '';
      clonedData[colIndex].relation.currControl = null;
      clonedData[colIndex].relation.filteredPageArray = relation?.pageArray || [];
      clonedData[colIndex].relation.controlsArray = [];
      clonedData[colIndex].relation.filteredControlsArray = [];
      clonedData[colIndex].relation.currentColumn = null;
    } else {
      controlRef.current.value = '';
      clonedData[colIndex].relation.filteredControlsArray = relation?.controlsArray || [];
      clonedData[colIndex].relation.currentColumn = null;
    }
    setState((prev) => ({
      ...prev,
      columnStateData: clonedData,
    }));
  };

  const clearRefs = (ref) => {
    if (ref.current) {
      ref.current.value = '';
    }
  };

  const clearFormula = () => {
    clearRefs(locationRef);
    clearRefs(subLocationRef);
    clearRefs(pageRef);
    clearRefs(controlRef);
    const clonedData = cloneDeep(columnStateData);
    clonedData[colIndex].relation.formulaArray = [];
    clonedData[colIndex].relation.formulaString = '';
    clonedData[colIndex].relation.readOnlyFormulaString = '';
    clonedData[colIndex].relation.counter = 0;
    clonedData[colIndex].relation.currSubLocation = null;
    clonedData[colIndex].relation.currPage = null;
    clonedData[colIndex].relation.currControl = null;
    clonedData[colIndex].relation.undo = [];
    clonedData[colIndex].relation.redo = [];
    clonedData[colIndex].relation.currLocation = {
      label: 'Product Core Information',
      name: 'Product_Core_Information',
      _id: 11,
    };
    clonedData[colIndex].relation.filteredLocationArray = relation?.locationArray;
    setState((prev) => ({
      ...prev,
      columnStateData: clonedData,
    }));
  };

  const undoFormula = () => {
    const copyFormulaArr = cloneDeep(relation?.formulaArray);
    if (Array.isArray(copyFormulaArr) && copyFormulaArr.length > 0) {
      const lastPopObject = copyFormulaArr.pop();
      const cloneRedoArr = [...(relation?.redo || [])];
      if (lastPopObject) {
        cloneRedoArr.push(lastPopObject);
      }
      const getObj = copyFormulaArr[copyFormulaArr.length - 1];
      let counter = relation?.counter || -1;
      if (getObj?.subLocation?.type === 'symbol' || !getObj) {
        counter = 0;
      } else if (getObj) {
        counter = 1;
      }
      updateFormulaString(copyFormulaArr, [...(relation?.redo || []), ...cloneRedoArr], copyFormulaArr, counter);
    }
  };

  const redoFormula = () => {
    let cloneRedo = [...(relation?.redo || [])];
    const copyFormulaArr = cloneDeep(relation?.formulaArray || []);
    if (cloneRedo.length > 0) {
      copyFormulaArr.push(cloneRedo.pop());
      cloneRedo = relation?.redo.slice(0, -1);
    }
    const getObj = copyFormulaArr[copyFormulaArr.length - 1];
    let counter = relation?.counter || -1;
    if (getObj?.subLocation?.type === 'symbol') {
      counter = 0;
    } else if (getObj) {
      counter = 1;
    }
    updateFormulaString(copyFormulaArr, cloneRedo, [...(relation?.undo || []), ...cloneRedo], counter);
  };

  const handleFilter = (val, filterBy) => {
    const clonedData = cloneDeep(columnStateData);
    if (filterBy === 'location') {
      const filteredData = relation?.locationArray?.filter((location) => location.label.toLowerCase().includes(val.toLowerCase()));
      clonedData[colIndex].relation.filteredLocationArray = filteredData;
    } else if (filterBy === 'subLocation') {
      const filteredData = relation?.subLocationArray?.filter((subLocation) => subLocation.label.toLowerCase().includes(val.toLowerCase()));
      clonedData[colIndex].relation.filteredSubLocationArray = filteredData;
    } else if (filterBy === 'page') {
      const filteredPage = relation?.pageArray?.filter((page) => page.label.toLowerCase().includes(val.toLowerCase()));
      clonedData[colIndex].relation.filteredPageArray = filteredPage;
    } else {
      const filteredControls = relation?.controlsArray?.filter((page) => page.label.toLowerCase().includes(val.toLowerCase()));
      clonedData[colIndex].relation.filteredControlsArray = filteredControls;
    }
    setState((prev) => ({
      ...prev,
      columnStateData: clonedData,
    }));
  };

  useEffect(() => {
    setDisableMainBtn(allowEditFormula);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allowEditFormula]);

  const handleFormulaDirectly = (val) => {
    const clonedData = cloneDeep(columnStateData);
    const string = val?.replace(/\s*\[(.*?)_.*?\]/g, '$1');
    clonedData[colIndex].relation.readOnlyFormulaString = string;
    setState((prev) => ({
      ...prev,
      columnStateData: clonedData,
    }));
  };

  const createNewSubColumns = () => {
    const getSectionsColumns = flatMap(cloneDeep(currSectionList?.map((dyCol) => dyCol?.columns)));
    return getSectionsColumns?.map((dyCol) => {
      const obj = {
        label: dyCol?.title,
      };
      if (dyCol?.columnType === 'calculation') {
        obj.name = dyCol?.formulaArr;
        obj.type = 'number';
      } else if (dyCol?.columnType === 'source') {
        obj.name = [dyCol?.source];
        obj.type = 'number';
      } else if (dyCol?.columnType === 'manual') {
        obj.name = dyCol?._id;
        obj.type = 'manualNumber';
        obj.numberType = dyCol?.key;
      }
      return obj;
    });
  };

  // this is function to create a new Formula array based on readonly string formula.
  //  ensure that the ladder stays in the respective order for proper value rendering.
  const handleResultValue = (result, newFormulaArray) => {
    let hasError = false;
    const calculationBtnArr = calculationBtnArrays(
      checkFormulaHasStringType,
      counterState,
      checkFormulaHasPercentageAtLast.percentage,
      checkFormulaHasPercentageAtLast.root,
      checkFormulaHasPercentageAtLast.disableNumbers,
      checkFormulaHasPercentageAtLast.disableSpecialCharacter,
      checkFormulaHasPercentageAtLast.piAtLast,
      checkFormulaHasPercentageAtLast.closingBreak,
    );
    result?.forEach((ele) => {
      const characters = calculationBtnArr?.find((val) => val?.name === ele);
      const subFilterRelation = (relation?.filteredSubLocationArray || [])?.find((val) => val?.label === ele);
      const subLocationValue = handleSubLocation(ele);
      const newSubColumns = createNewSubColumns();
      const foundSubColumn = newSubColumns?.find((val) => val?.label === ele);
      if (characters) {
        newFormulaArray.push({ location: characters, subLocation: characters });
      } else if (subFilterRelation) {
        newFormulaArray.push({ location: subFilterRelation, subLocation: subFilterRelation });
      } else if (subLocationValue) {
        newFormulaArray.push(subLocationValue);
      } else if (parseFloat(ele)) {
        const splitDigits = parseFloat(ele)?.toString()?.split('');
        if (splitDigits?.length > 0) {
          hasError = handleResultValue(splitDigits, newFormulaArray);
        }
      } else if (foundSubColumn) {
        newFormulaArray.push(...(foundSubColumn?.name || []));
      } else {
        hasError = true;
      }
    });
    return hasError;
  };

  const handleNewFormulaArray = (newFormulaArray) => {
    const hasString = newFormulaArray?.find((val) => val?.subLocation?.type === 'string');
    let finalNewFormulaArray = newFormulaArray;
    if (hasString) {
      const filteredArr = newFormulaArray?.filter((val) => !['(', ')', '%'].includes(val?.subLocation?.name));
      finalNewFormulaArray = filteredArr?.map((formulaELe) => {
        if (['+', '-', '*', '/', 'π', '²', '√'].includes(formulaELe?.subLocation?.name)) {
          return {
            location: { name: '&', label: '&', type: 'symbol' },
            subLocation: { name: '&', label: '&', type: 'symbol' },
          };
        }
        return formulaELe;
      });
    }
    const lastObj = last(finalNewFormulaArray);
    let counter = 0;
    if (
      [')', 'X²', 'π'].includes(lastObj?.subLocation?.name) ||
      ['number', 'Number', 'Number_percentage'].includes(lastObj?.subLocation?.type) ||
      lastObj?.subLocation?.type === 'string' ||
      (lastObj?.subLocation?.type === 'symbol' && lastObj?.subLocation?.name === '%')
    ) {
      counter = 1;
    }
    updateFormulaString(finalNewFormulaArray, [...(relation?.redo || [])], finalNewFormulaArray, counter || relation?.counter);
  };

  const handleEditClick = () => {
    if (allowEditFormula) {
      if (relation?.readOnlyFormulaString?.length > 0) {
        const result = splitAndFilterString(relation?.readOnlyFormulaString);
        let hasError = false;
        const newFormulaArray = [];
        if (result.length > 0) {
          hasError = handleResultValue(result, newFormulaArray);
        }
        if (hasError) {
          setFormulaHasError(true);
          return;
        }
        if (newFormulaArray.length > 0) {
          handleNewFormulaArray(newFormulaArray);
        }
        setFormulaHasError(false);
      } else {
        setFormulaHasError(true);
        return;
      }
    }
    setAllowEditFormula(!allowEditFormula);
  };

  function checkUnderscore(input) {
    if (input.includes('_')) {
      return input.split('_')[0]; // Split by underscore and return 0th position
    }
    return input; // Return the original input if no underscore is found
  }

  const handleOtherConfig = (e) => {
    const object = cloneDeep(element);

    const propertyName = checkUnderscore(e.target.name);
    const isCheckbox = e.target.type === 'checkbox';
    const propertyValue = isCheckbox ? e.target.checked : e.target.value;

    const addedObj = { [propertyName]: propertyValue };

    const settings = { ...(object?.otherConfiguration || {}), ...addedObj };

    onChange(settings, colIndex, 'otherConfiguration');
  };

  const handleFontSize = (style) => {
    onChange(style, colIndex, 'fontSize');
  };

  return (
    <>
      <div className="column-card">
        <div className="control">
          <Select
            options={tableControls}
            getOptionLabel={(option) => `${option?.label}`}
            getOptionValue={(option) => `${option?.key}`}
            maxMenuHeight={160}
            menuPosition="fixed"
            inputProps={{
              autoComplete: 'off',
              autoCorrect: 'off',
              spellCheck: 'off',
            }}
            styles={customStylesWithBorderRight}
            className="common-select"
            classNamePrefix="common-select"
            value={selectValue}
            onChange={(val) => onChange(val, colIndex, 'key')}
          />

          {element?.key === 'Source' && (
            <div>
              <TableSourceComponent
                columnIndex={colIndex}
                handleChange={handleChange}
                relation={relation}
                locationOptions={locationOptions}
                customOptions={customOptions}
                controlOptions={controlOptions}
                manualCustomColumns={manualCustomColumns}
                hasError={errors[colIndex]?.error}
              />
            </div>
          )}
          {element?.key === 'Calculation' && (
            <div>
              <TableCalculation
                pageRef={pageRef}
                controlRef={controlRef}
                columnIndex={colIndex}
                relation={relation}
                colourArray={element?.colourArray}
                onLocationChange={onLocationChange}
                redoFormula={redoFormula}
                undoFormula={undoFormula}
                clearFormula={clearFormula}
                clearLocation={clearLocation}
                handleFilter={handleFilter}
                locationRef={locationRef}
                subLocationRef={subLocationRef}
                hasError={errors[colIndex]?.error}
                handleFormulaDirectly={handleFormulaDirectly}
                handleEditClick={handleEditClick}
                allowEditFormula={allowEditFormula}
                childOptions={childOptions}
                formulaHasError={formulaHasError}
                hideCustomModule={hideCustomModule}
                rootAtLast={rootAtLast}
                onChange={onChange}
              />
            </div>
          )}
          {element?.key === 'Dependent' && (
            <div>
              <TableDependent
                columnIndex={colIndex}
                handleChange={handleDependentChange}
                relation={relation}
                hasError={errors[colIndex]?.error}
                setState={setState}
                addContent={addContent}
                deleteCard={deleteCard}
                i={i}
              />
            </div>
          )}
          {keyHasOption?.includes(element?.key) && (
            <div className="mt-3">
              <p className="mb-2">{t('CUSTOM_MODULES.LIBRARY.TABLE.COLUMN_CARD.OPTIONS')}</p>
              {element?.options?.map((eleOption, optIndex) => {
                return (
                  <div key={eleOption?.id} className="option-row">
                    <input
                      type="text"
                      onChange={(e) => handleOptionChange(e, optIndex, colIndex, element?.key)}
                      onBlur={() => handleBlurOption(optIndex, colIndex)}
                      value={eleOption?.label}
                      className="form-control text-bordered"
                      maxLength={50}
                    />
                    {element?.options?.length === optIndex + 1 ? (
                      <>
                        {element?.options?.length > 1 && (
                          <button
                            className="btn btn-outline ml-1"
                            title={t(deleteOptions)}
                            aria-label={t(deleteOptions)}
                            onClick={() => handleDeleteOption(optIndex, colIndex)}
                            type="submit"
                          >
                            <i className="icon icon-delete" />
                          </button>
                        )}
                        <button
                          className="btn btn-outline ml-1"
                          title={t('CUSTOM_MODULES.LIBRARY.TABLE.COLUMN_CARD.ADD_OPTION')}
                          aria-label={t('CUSTOM_MODULES.LIBRARY.TABLE.COLUMN_CARD.ADD_OPTION')}
                          onClick={() => handleAddMoreOption(colIndex)}
                          type="submit"
                        >
                          <i className="icon icon-add" />
                        </button>
                      </>
                    ) : (
                      <button
                        className="btn btn-outline ml-1"
                        title={t(deleteOptions)}
                        aria-label={t(deleteOptions)}
                        onClick={() => handleDeleteOption(optIndex, colIndex)}
                        type="submit"
                      >
                        <i className="icon icon-delete" />
                      </button>
                    )}
                  </div>
                );
              })}
            </div>
          )}
          {/* Code for Status control */}
          {element?.key === 'Status' && (
            <div className="status-config-container">
              <div className="input-group form-floating-label fixed-label">
                <button
                  type="button"
                  className="btn btn-default w-100 m-0 mb-2"
                  value={isStatusEditTrue}
                  onClick={() => setIsStatusEditTrue(!isStatusEditTrue)}
                >
                  <span className="icon-edit mr-2" />
                  {t('CUSTOM_MODULES.LIBRARY.TABLE.COLUMN_CARD.EDIT_COLOR')}
                </button>
                {element?.statusColours?.map((stat, keyIn) => {
                  return (
                    <button
                      type="button"
                      key={stat}
                      className="status-color-option"
                      aria-label="colour option"
                      onClick={() => onChange(true, colIndex, 'setDefault', keyIn)}
                      style={
                        stat?.setDefault
                          ? {
                              border: '2px solid #8d8dff',
                            }
                          : {}
                      }
                    >
                      <div className="color-content">
                        <input
                          type="color"
                          className="form-control"
                          value={stat?.colourHexCode}
                          onChange={(e) => onChange(e.target.value, colIndex, 'colourHexCode', keyIn)}
                          disabled={!isStatusEditTrue}
                        />
                      </div>
                      <input
                        type="text"
                        className="text-content fs-custom-module"
                        value={stat?.colourName}
                        placeholder={t('CUSTOM_MODULES.LIBRARY.TABLE.COLUMN_CARD.ADD_COLOUR_NAME')}
                        onChange={(e) => onChange(e.target.value, colIndex, 'colourName', keyIn)}
                        readOnly={!isStatusEditTrue}
                      />
                    </button>
                  );
                })}
              </div>
            </div>
          )}
          {/* Code for Number Percentage control */}
          {(element?.key === 'Number_Percentage' || element?.key === 'Number_Decimal') && (
            <div className="pt-3">
              <Accordion key={`Column_${0}`}>
                <Card className="rounded-0 ">
                  <Card.Header className="d-flex align-items-center bgcolor-dark rounded-0 py-1 px-2">
                    <div className="d-flex p-2 align-items-center reducing-switch-z-index">
                      <div className="custom-control custom-switch line-h-initial">
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          id="colourSwitch_"
                          name="colourSwitch_"
                          onChange={(e) => forSwitch(e)}
                          checked={colourSwitch}
                        />
                        <label className="custom-control-label p-0" htmlFor="colourSwitch_">
                          {t('CUSTOM_MODULES.LIBRARY.TABLE.COLUMN_CARD.COLOUR_CODING')}
                        </label>
                      </div>
                    </div>
                    <span className="ml-auto">
                      <span className="icon-new-down-arrow-icon" />
                    </span>
                  </Card.Header>
                  {colourSwitch && (
                    <Card.Body>
                      <div className="flex-fill">
                        {element?.colourArray?.map((eleNoCol, index) => {
                          return (
                            <div className="d-flex align-items-center fs-custom-module mb-2" key={eleNoCol}>
                              <div className="status-color-container d-flex">
                                <span className={`${eleNoCol?.colourType} rount-shape`} />
                              </div>
                              <div className="d-flex flex-wrap align-items-center">
                                <span className="px-2 text-nowrap">if</span>
                                <div className="w-180 px-2 my-1 my-md-0">
                                  <Select
                                    name="colourValue"
                                    options={ColumnValues?.filter((ele) => !element?.colourArray?.map((e) => e?.colourValue)?.includes(ele?._id))}
                                    getOptionLabel={(option) => `${option.name}`}
                                    getOptionValue={(option) => `${option._id}`}
                                    menuPlacement="bottom"
                                    menuPosition="fixed"
                                    isClearable
                                    menuShouldBlockScroll
                                    menuShouldScrollIntoView
                                    value={chcekingFromDynamicArray(ColumnValues, eleNoCol?.colourValue) || null}
                                    styles={customStylesForOCP}
                                    maxMenuHeight={140}
                                    onChange={(e) => onChange(e, colIndex, 'colourValue', index)}
                                    placeholder={t('CUSTOM_MODULES.LIBRARY.TABLE.COLUMN_CARD.SELECT_VALUE')}
                                  />
                                </div>
                                <input
                                  className="form-control text-bordered percentaage-input mx-2"
                                  onChange={(e) => onChange(e?.target?.value, colIndex, 'startPercentage', index)}
                                  disabled={!eleNoCol?.colourValue}
                                  value={eleNoCol?.startPercentage}
                                  name={`colourStateValue_start_${index}`}
                                  type="number"
                                />
                                {element?.key === 'Number_percentage' && '%'}
                                {eleNoCol?.colourValue === 'between' && (
                                  <div className="d-flex align-items-center ml-1">
                                    {' and '}
                                    <input
                                      className="form-control text-bordered percentaage-input mx-2"
                                      onChange={(e) => onChange(e?.target?.value, colIndex, 'endPercentage', index)}
                                      disabled={!eleNoCol?.colourValue}
                                      value={eleNoCol?.endPercentage}
                                      name={`colourStateValue_end_${index}`}
                                      type="number"
                                    />
                                    {element?.key === 'Number_percentage' && '%'}
                                  </div>
                                )}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </Card.Body>
                  )}
                </Card>
              </Accordion>
            </div>
          )}
          {/* Code for Signature control */}
          {element?.key === 'Signature' && (
            <div className="pt-3">
              <div className="custom-tabs">
                <Tabs defaultActiveKey="type" id="uncontrolled-tab-example">
                  <Tab eventKey="type" title={t('CUSTOM_MODULES.LIBRARY.TABLE.COLUMN_CARD.TYPE')}>
                    <div className="d-flex flex-wrap">
                      <input
                        type="text"
                        placeholder={element?.placeholder}
                        onChange={(e) => onChange(e.target.value, colIndex, 'placeholder')}
                        value={element?.placeholder}
                        className="form-control text-bordered table-sign-placeholder"
                      />
                      {element?.fontStyles?.map((eleFont) => {
                        return (
                          <div className="sign-container" key={eleFont}>
                            {element?.placeholder && (
                              <button
                                type="button"
                                className={element?.fontFamily === eleFont?.font ? 'active' : ''}
                                onClick={() => handleFont(eleFont?.font)}
                                style={{ fontFamily: eleFont?.font }}
                              >
                                {element?.placeholder}
                              </button>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  </Tab>
                  <Tab eventKey="upload" title={t('CUSTOM_MODULES.LIBRARY.TABLE.COLUMN_CARD.UPLOAD')}>
                    <div className="text-center p-3">
                      <div className="image-upload-container">
                        <figure>
                          <img className="img-thumb" src={getImage(element?.digitalSignPath) || noImage} alt="" />
                        </figure>
                        <div className="btn-container">
                          <button
                            type="button"
                            onClick={() => handleUploadImage('Signature')}
                            className="btn"
                            aria-label={t('CUSTOM_MODULES.LIBRARY.TABLE.COLUMN_CARD.UPLOAD')}
                          >
                            <i className="icon-upload mr-2" />
                          </button>
                          {element?.digitalSignPath !== '' && (
                            <button
                              type="button"
                              onClick={() => handleRemoveImage('Signature')}
                              className="btn"
                              aria-label={t('CUSTOM_MODULES.LIBRARY.TABLE.TABLE_CONTROL.DELETE')}
                            >
                              <i className="icon-delete mr-2" />
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </Tab>
                </Tabs>
              </div>
            </div>
          )}
          {/* Code for Number Company Stamp control */}
          {element?.key === 'Company_Stamp' && (
            <div className="p-3">
              <div className="text-center p-3">
                <div className="image-upload-container">
                  <figure>
                    <img className="img-thumb" src={getImage(element?.companyLogo) || noImage} alt="" />
                  </figure>
                  <div className="btn-container">
                    <button
                      type="button"
                      onClick={() => handleUploadImage(varCompanyStamp)}
                      className="btn"
                      aria-label={t('CUSTOM_MODULES.LIBRARY.TABLE.COLUMN_CARD.UPLOAD')}
                    >
                      <i className="icon-upload mr-2" />
                    </button>
                    {element?.companyLogo !== '' && (
                      <button
                        type="button"
                        onClick={() => handleRemoveImage(varCompanyStamp)}
                        className="btn"
                        aria-label={t('CUSTOM_MODULES.LIBRARY.TABLE.TABLE_CONTROL.DELETE')}
                      >
                        <i className="icon-delete mr-2" />
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
          {/* Code for Number Label control */}
          {element?.key === 'Label' && (
            <div className="pt-3">
              <DndProvider backend={HTML5Backend}>
                {element?.labelColours?.map((labelEle, labelIndex) => {
                  return renderlabelList(labelEle, labelIndex);
                })}
              </DndProvider>
            </div>
          )}
          {!relation?.loading && (
            <>
              <div className="common-input-control mt-16">
                <p className="field-name">{t('CUSTOM_MODULES.LIBRARY.TABLE.COLUMN_CARD.FIELD_NAME')}</p>
                <input
                  type="text"
                  placeholder={t('CUSTOM_MODULES.LIBRARY.TABLE.COLUMN_CARD.ENTER_COLUMN_TYPE')}
                  onChange={(e) => onChange(e.target.value, colIndex, 'fieldName')}
                  onBlur={() => handleBlur(colIndex, 'fieldName')}
                  value={element?.fieldName || ''}
                  maxLength={200}
                  className="form-control"
                />

                <div className="text-count">{element?.fieldName?.length || 0}/200</div>
              </div>
              {errors[colIndex]?.error && !element?.fieldName?.length && <p className="error-message mb-0">{t('CUSTOM_MODULE.COLUMN_NAME_REQUIRED')}</p>}
              {errors[colIndex]?.error && !['Calculation', 'Source'].includes(element?.key) && (
                <p className="error-message mb-0">{t('CUSTOM_MODULE.ALL_FIELDS_REQUIRED')}</p>
              )}
            </>
          )}
          {alignBoldControls.includes(element?.key) && (
            <>
              <div className="mt-16">
                <AlignmentConfigComp obj={element} handleAlignment={handleOtherConfig} noPadding index={colIndex} />
              </div>
              <div className="mt-16">
                <BoldConfigComp obj={element} handleBold={handleOtherConfig} noPadding index={colIndex} />
              </div>
            </>
          )}
          {element?.key === 'Text_Area' && (
            <div className="mt-16 w-200px">
              <p className="mb-0 f-14">{t('CUSTOM_MODULE.FONT_SIZE')}</p>
              <Select
                name="Supplier"
                type="text"
                placeholder={t('CUSTOM_MODULE.FONT_SIZE')}
                options={fontSizeTextControl}
                styles={customStyles}
                className="common-select"
                classNamePrefix="common-select"
                menuPosition="fixed"
                getOptionLabel={({ label }) => `${label}`}
                getOptionValue={({ value }) => `${value}`}
                value={element?.fontSize}
                onChange={(selected) => handleFontSize(selected)}
              />
            </div>
          )}
          {element?.key === 'Date_Picker' && (
            <div className="checkbox-label my-3" key="range_0">
              <input
                type="checkbox"
                id={`isRange_${colIndex}`}
                key={`isRange_${colIndex}`}
                name="Enable"
                checked={element?.range}
                onChange={(e) => onChange(e.target.checked, colIndex, 'range')}
              />
              <label htmlFor={`isRange_${colIndex}`} className="chklabel">
                <span>{t('CUSTOM_MODULE.IS_RANGE_TYPE')}</span>
              </label>
            </div>
          )}
        </div>
        {!editMode &&
          (columnStateData?.length === colIndex + 1 ? (
            <button
              type="button"
              title={t('CUSTOM_MODULES.LIBRARY.TABLE.COLUMN_CARD.ADD_COLUMN')}
              aria-label={t('CUSTOM_MODULES.LIBRARY.TABLE.COLUMN_CARD.ADD_COLUMN')}
              onClick={() => handleAddColumn()}
              className="btn btn-outline"
              disabled={allowEditFormula}
            >
              <i className="icon icon-add" />
            </button>
          ) : (
            <button
              type="button"
              title={t('CUSTOM_MODULES.LIBRARY.TABLE.COLUMN_CARD.DELETE_COLUMN')}
              aria-label={t('CUSTOM_MODULES.LIBRARY.TABLE.COLUMN_CARD.DELETE_COLUMN')}
              onClick={() => handleDeleteColumn(colIndex)}
              className="btn btn-outline"
              disabled={allowEditFormula}
            >
              <i className="icon icon-delete" />
            </button>
          ))}
      </div>
      {imageModal.isOpen && (
        <UploadImageModal childRef={childRef} element={element} imageModal={imageModal} getImage={getImage} handleImageUpload={handleImageUpload} />
      )}
    </>
  );
}

export default ColumnCard;
